module.exports = __webpack_public_path__ + "img/privacy_jp.5c560b1.jpg";